import type { ClientDocumentPayload, ClientDocumentWithPassportData } from '@/types/clientsApiTypes';
import { formatMMDDYYYYToYYYYMMDD } from '@/utils/formatDate';

export const getDocumentPayload = (
  document: Partial<ClientDocumentWithPassportData>
): Partial<ClientDocumentPayload> => {
  const fields: { [K in keyof ClientDocumentPayload]: unknown } = {
    document_type: document.document_type,
    document_name: document.document_name,
    passport_number: document.passport_number,
    expiry_date: formatMMDDYYYYToYYYYMMDD(document.expiry_date),
    issue_date: formatMMDDYYYYToYYYYMMDD(document.issue_date),
    issuance_country: document.issuance_country,
  };

  return Object.entries(fields).reduce<Partial<ClientDocumentPayload>>((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key as keyof ClientDocumentPayload] = value as never;
    }
    return acc;
  }, {});
};
